export default __webpack_public_path__ + "static/media/ExcavationCampMap.a84fcdf4.jpg";